<template>
  <v-container>
    <addresses-list />

    <v-btn dark fixed bottom right fab @click="create" color="accent">
      <v-icon>mdi-plus</v-icon>
    </v-btn>
  </v-container>
</template>

<script>
import AddressesList from '@/components/addresses/AddressesList';

export default {
  methods: {
    create() {
      this.$router.push({ name: 'addresses-cadastre' });
    },
  },
  components: {
    AddressesList,
  },
};
</script>
